<template>
    <v-container class="ma-0 pa-0">
        <v-row style="width: 400px !important;" class="ma-0 pa-0">
            <v-col :cols="cols">
                <v-img
                    v-if="!right"
                    src='@/assets/pic/web/oak_avatar.png'
                    :max-width="width"
                    :max-height="width"
                    style="transform: scaleX(-1)"
                />
            </v-col>
            <v-col
                v-if="!multiple"
                :class="{'font-weight-bold' : bold}"
            >
                {{value}}
            </v-col>
            <v-col
                v-if="multiple"
            >
                <p v-for="(val,index) in value" :key="index" :class="{'font-weight-bold' : bold}">
                    {{val}}
                </p>
            </v-col>
            <v-col :cols="cols">
                <v-img
                    v-if="right"
                    class="float-right"
                    src='@/assets/pic/web/oak_avatar.png'
                    :max-width="width"
                    :max-height="width"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        props: {
          value: {String, default: ''},
          right: {Boolean, default: false},
          multiple: {Boolean, default: false},
          big: {Boolean, default: false},
          bold: {Boolean, default: false},
        },
        data() {
            return {
            }
        },
        computed: {
            ...mapGetters({
            }),
            width(){
                return this.big ? 150 : null;
            },
            cols(){
                return this.big ? 3 : 2;
            },
        },
        watch: {
        },
        created() {
            this.getUsers();
        },
        methods: {
            ...mapActions({
                getUsers: 'user/loadItems',
                getLoadUser: 'user/loadItem'
            }),
        },
    }
</script>

